<div class="relative overflow-visible select-none"
     [style.width.px]="60 * scale()!"
     [style.height.px]="30 * scale()!">

  <div class="absolute top-0 left-0 w-[60px] h-[30px] rounded-full border transition-all duration-300 origin-top-left flex items-center cursor-pointer"
       [ngClass]="{
         'bg-indigo-600 border-indigo-600 shadow-sm shadow-indigo-500/20': active() && !disabled(),
         'bg-slate-300/90 border-slate-300 hover:bg-slate-300 hover:border-slate-400 dark:bg-white/10 dark:border-white/10 dark:hover:bg-white/15': !active() && !disabled(),
         'bg-slate-100 border-slate-200 dark:bg-white/5 dark:border-white/5 opacity-50 cursor-not-allowed': disabled()
       }"
       [style.transform]="'scale(' + scale() + ')'"
       (click)="!disabled() && toggle()">

    <div class="absolute h-[24px] w-[24px] rounded-full bg-white shadow-md shadow-slate-900/10 transition-all duration-300"
         [ngClass]="{
           'left-[32px]': active(),
           'left-[2px]': !active()
         }">
    </div>

  </div>
</div>
